import NftPools from 'views/Pools'

const NftPoolsPage = () => {
    return <NftPools tokenMode />
}

export default NftPoolsPage